<template>
    <page-container2 style="flex-direction: column;" title="用户管理" showRefreshBtn @refresh="$refs.pageTable.load()">
        <template v-slot:buttons>
            <permission-container permissionId="System.User.Add">
                <el-button type="primary" size="mini" @click="add">添加</el-button>
            </permission-container>
        </template>
        <pagination-table ref="pageTable" :tableList="tableList" showCloseBtn tablePermissionId="System.User.List">
<!--            <template v-slot:searchForm>-->
<!--                <el-form-item label="用户名">-->
<!--                    <el-input v-model="tableList.searchForm.username" placeholder="用户名"></el-input>-->
<!--                </el-form-item>-->
<!--            </template>-->
            <template v-slot:tableColumns>
                <el-table-column
                    type="index"
                    label="序号"
                    width="50"
                    align="center"
                    >
                </el-table-column>

                <el-table-column
                    prop="username"
                    label="登录账号">
                </el-table-column>
                <el-table-column
                    prop="nickname"
                    label="昵称">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    label="创建时间"
                    width="180">
                    <template slot-scope="scope">
                        <date-time-render :value="scope.row.createTime"/>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="updateTime"
                    label="更新时间"
                    width="180">
                    <template slot-scope="scope">
                        <date-time-render :value="scope.row.updateTime"/>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="180"
                    >
                    <template slot-scope="scope">
                        <permission-container permissionId="System.User.Edit">
                            <el-button
                                size="mini"
                                @click="edit(scope.row, scope.$index)">编辑</el-button>
                        </permission-container>
                        <permission-container permissionId="System.User.Delete">
                            <el-button
                            size="mini"
                            type="danger"
                            @click="deleteUser(scope.row, scope.$index)">删除</el-button>
                        </permission-container>
                    </template>
                </el-table-column>
            </template>
        </pagination-table>
    </page-container2>
</template>

<script>
import List from "@/components/table/List";

export default
{
    name: "UserList",
    data()
    {
        return {
            tableList: new List({url: '/system/user/list'})
        }
    },
    created()
    {
        console.log('list created');
    },
    mounted()
    {
    },
    methods:
    {
        add()
        {
            let bridge = this.dispatchRouteTo('/user/edit');
            bridge.onRouteBack = ()=>
            {
                this.tableList.load();
            }
        },
        edit(rowData, index)
        {
            console.log(rowData, index);
            let bridge = this.dispatchRouteTo('/user/edit', {id: rowData.id});
            bridge.onRouteBack = ()=>
            {
                this.tableList.load();
            }
        },
        deleteUser(rowData, index) {
            console.log(rowData, index);
            return this.showConfirm("确定要删除用户吗？").
            then((result)=>{
                if(!result) return;
                return Fx.Http.post("/system/user/delete", {id: rowData.id}).
                then((resp)=>
                {
                    if(resp.isSuccess()) {
                        this.showMessageSuccess('删除成功', ()=>
                        {
                            this.tableList.load();
                        })
                    } else {
                        this.showMessageError(resp.getErrorMessage());
                    }
                })
            })
        }
    }
}
</script>

<style scoped lang="scss">
.pagination-container
{
    display: flex;
    justify-content: center;
    padding: 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/modules/system/pages/user/List.vue